import React, {Fragment} from 'react';
import {
    Card,
    Table,
    Menu,
    Dropdown,
    Space,
    Input,
    Row,
    Button,
    Typography,
    Modal,
    Form,
    Select,
    Checkbox,
    TimePicker,
    InputNumber,
    notification, AutoComplete, DatePicker, Collapse
} from "antd";

import {
    DownOutlined,
    DownloadOutlined,
    DeleteOutlined,
    PlusOutlined,
    MinusCircleOutlined,
    EuroCircleOutlined
} from '@ant-design/icons';


import ApiService from "../services/ApiService"

import IntlMessage from "../components/util-components/IntlMessage";
import RestrictedAlert from "../components/permissions/RestrictedAlert";
import moment from "moment"
import PermissionAlert from "../components/permissions/PermissionAlert";
import FormAsso from "../views/app-views/infos/FormAsso";
import MultiAssocForm from "../components/custom-fields/MultiAssocForm";
import ContactIcon from "../components/util-components/ContactIcon";
import {getDevise, getDeviseSymbol} from "../components/permissions/functions";
import {connect} from "react-redux";
import ModalEditContact from "../views/app-views/contact/ModalEdit";

import {t} from "@lingui/core/macro"
import {Trans} from "@lingui/react/macro"
import CampagneAddonForm from '../components/CampagneAddonForm';

const {Search} = Input;
const {Text} = Typography;
const {Option} = Select;


class ModalPromesse extends React.Component {

    constructor(props) {
        super(props);
        props.getRef(this)
    }

    initialState = {
        visible: false,
        loading: false,
        edit: false,
        occasions: [],
        types: [],
        defaultData: {montant: 1, date: moment()},
        id: null,
        type: "CONTACT",
        detteId: null,
        typesComptes: [],
        typeCompte: null,

        contacts: [],
        _contact: null,
    }

    state = this.initialState;

    async selectContact(){
        return new Promise((resolve)=>{
            this.modalEditContact.selectOrCreate((d)=>{
                resolve(d)
            })
        })
    }

    async show(id = null, type = "CONTACT") {
        let tasks = [this.initTypes(), this.initOccasions(), this.getTypesComptes()]
        if (!id) {
            const selectedContact=await this.selectContact()
            console.log("selectedContact",selectedContact)
            id=selectedContact.id
            //tasks.push(this.getContacts())
        }

        await Promise.all(tasks)
        this.setState({visible: true, id: id, type: type, typeCompte: this.state.typesComptes[0]})
    }

    async edit(id, contact) {
        await Promise.all([this.initTypes(), this.initOccasions(), this.getTypesComptes()])
        var data = await this.getData(id)

        data.date = moment(data.date)

        var typeCompte = this.state.typesComptes.find(i => i.value === data.typeId)
        if (!typeCompte) {
            typeCompte = this.state.typesComptes[0]
        }

        this.setState({
            edit:true,
            visible: true,
            id: contact,
            type: "CONTACT",
            typeCompte: typeCompte,
            detteId: id,
            defaultData: {...data}
        })
    }

    close() {
        this.setState(this.initialState)
    }

    async getData(id) {
        var res = await ApiService.get("/promesses/id/" + id)
        if (res.success) {
            return res.data
        }
        return null
    }

    async getContacts() {
        var res = await ApiService.get("/contact/form?withAdresse=1")
        this.setState({contacts: res.data})
    }

    async initTypes() {
        var res = await ApiService.get("/promesses/types")
        if (res.success) {
            this.setState({types: res.items})
        }
    }

    async initOccasions() {
        const DEFAULT=[`Tichri`,`Pessah`,`Chavouot`,`Chabbat`]

        var res = await ApiService.get("/promesses/occasions")
        if (res.success) {
            this.setState({occasions:  [...new Set(DEFAULT.concat(res.items).sort())] })
        }
    }

    async getTypesComptes() {
        const DEFAULT=[`Rosh Hashana`,`Yom Kipour`,`Souccot`]
        var res2 = await ApiService.get("/paiements/cerfa/types/?groupe=1")
        console.log(res2)
        this.setState({typesComptes: [...new Set(DEFAULT.concat(res2.items).sort())] })
    }

    async onSubmit(data) {
        if (this.state.type == "COMPTE") {
            data.compte = this.state.id
        } else {
            data.contact = this.state.id
        }

        if (this.state.detteId) {
            data.id = this.state.detteId
        }

        data.date = new Date(data.date.toDate())
        data.date.setHours(0, 0, 0, 0)

        data.typeId = this.state.typeCompte.value

        console.log(data)

        //return false

        if (!this.state.id) {
            notification.error({
                message: (<IntlMessage id="error.edit"/>)
            })
            this.close()
            return false
        }

        var url = "/promesses/add"
        if (this.state.type == "CONTACT") {
            url = "/promesses/edit"
        }
        var res = await ApiService.post(url, data)
        console.log(res)

        if (res.success) {
            notification.success({
                message: (<IntlMessage id="success.add"/>)
            })

            this.close()
            if (this.props.onFinish) {
                this.props.onFinish()
            }
        } else {
            notification.error({
                message: (<IntlMessage id="error.add"/>)
            })
        }
    }

    render() {
        return (
            <Fragment>

                <Modal width="100%" title={this.state.edit ? t`Éditer une Promesse de don` : t`Ajouter une Promesse de don`}
                       open={this.state.visible} destroyOnClose closable footer={null} onCancel={() => this.close()}>
                    <RestrictedAlert type="AUTH"
                                     condition={(i) => i.key == "Forfait" && ["FINANCE", "FULL", "PROMESSE"].includes(i.value)}>
                        <PermissionAlert permissions={["paiement.add"]}>

                            {!this.state.id && (
                                <div style={{
                                    margin: "50px 0px",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}>
                                    <div style={{width: "30%", minWidth: 300, maxWidth: "100%"}}>
                                        <Form.Item>
                                            <Select style={{minWidth: 300, marginRight: 5, marginBottom: 5}}
                                                    placeholder={t`Choisir un Contact`} showSearch
                                                    filterOption={(input, option) => {
                                                        var text = option.props.children
                                                        if (Array.isArray(text)) {
                                                            text = text.join("")
                                                        }
                                                        return text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }}
                                                    onChange={(value) => this.setState({_contact: value})}
                                            >
                                                {this.state.contacts.map((item, index) => {
                                                    var telValue = ""
                                                    if (item.tel) {
                                                        telValue = "(" + item.tel + ")"
                                                    }

                                                    var emailValue = ""
                                                    if (item.email) {
                                                        emailValue = "(" + item.email + ")"
                                                    }

                                                    return <Select.Option key={index} value={item.id}><ContactIcon
                                                        contact={item}/> {item.prenom} {item.nom} {telValue} {emailValue}
                                                    </Select.Option>
                                                })}
                                            </Select>
                                        </Form.Item>

                                        <Form.Item style={{display: "flex", justifyContent: "flex-end"}}>
                                            <Button onClick={() => this.setState({id: this.state._contact})} type="primary"
                                                    loading={this.state.loading}>
                                                <Trans>Valider</Trans>
                                            </Button>
                                        </Form.Item>
                                    </div>
                                </div>
                            )}


                            {this.state.id && (


                                <Form
                                    initialValues={this.state.defaultData}
                                    onFinish={(data) => this.onSubmit(data)}
                                >

                                    <MultiAssocForm devise={this.state.defaultData?.devise} defaultPointer={this.state.defaultData.pointer}/>


                                    <Form.Item
                                        label={t`Occasion`}
                                        name="occasion"
                                    >
                                        <AutoComplete
                                            options={this.state.occasions.map((item, index) => {
                                                return {
                                                    value: item,
                                                    label: item
                                                }
                                            })}
                                            filterOption={(inputValue, option) =>
                                                option.value.indexOf(inputValue) == -1
                                            }
                                            placeholder={t`Créer un nouveau ou choisissez une occasion existante`}
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        label={t`Type`}
                                        name={'type'}
                                    >
                                        <AutoComplete
                                            options={this.state.types.map((item, index) => {
                                                return {
                                                    value: item,
                                                    label: item
                                                }
                                            })}
                                            filterOption={(inputValue, option) =>
                                                option.value.indexOf(inputValue) == -1
                                            }
                                            placeholder={t`Créer un nouveau ou choisissez un type existant`}
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        label={t`Raison`}
                                        name={'name'}
                                    >
                                        <Input placeholder={t`Exemple: 3ème montée Shabbat Berechit`}/>
                                    </Form.Item>

                                    <Form.Item noStyle shouldUpdate>
                                        {(form)=>{
                                            const assocId=form.getFieldValue("assoc") || "MAIN"
                                            const devise=this.props.org.cerfasInfos.find(i=>i.id===assocId)?.devise || getDevise()
                                            return(
                                                <Form.Item
                                                    label={t`Montant`}
                                                    name={'montant'}
                                                    rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                                                >
                                                    <InputNumber
                                                        decimalSeparator={','} min={1}
                                                        step={0.5}
                                                        addonAfter={getDeviseSymbol(devise)}
                                                    />
                                                </Form.Item>
                                            )
                                        }}
                                    </Form.Item>


                                    <Form.Item
                                        label={t`Date`}
                                        name="date"
                                        rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                                    >
                                        <DatePicker format={"DD/MM/YYYY"}/>
                                    </Form.Item>


                                    <Form.Item
                                        label={t`Livret`}
                                    >
                                        <Select value={this.state.typeCompte?.value}
                                                style={{minWidth: 300, maxWidth: "100%"}}
                                                placeholder={t`Livret`} onChange={(value) => {
                                            const item = this.state.typesComptes.find(i => i.value == value)
                                            this.setState({typeCompte: item})
                                        }}>
                                            {this.state.typesComptes.map((item, index) => {
                                                return <Option key={index} value={item.value}>{item.label}</Option>
                                            })}
                                        </Select>
                                    </Form.Item>


                                    {this.state.typeCompte?.type === "CAMPAGNE" && (
                                        <CampagneAddonForm name={"campagne"} campagneId={this.state.typeCompte?.value}/>
                                    )}

                                    <Form.Item style={{display: "flex", justifyContent: "flex-end"}}>
                                        <Button type="primary" htmlType="submit" loading={this.state.loading}>
                                            <Trans>Valider</Trans>
                                        </Button>
                                    </Form.Item>

                                </Form>
                            )}
                        </PermissionAlert>
                    </RestrictedAlert>
                </Modal>
                <ModalEditContact getRef={(ref) => this.modalEditContact = ref}/>
            </Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        org: state.auth.org
    }
}

export default connect(mapStateToProps)(ModalPromesse)
